import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

export const validate: FormValidator<Pick<ChallengeFormType, 'tagIds'>> = ({
  tagIds,
}) => {
  if (!tagIds) return { isValid: false, message: '태그를 확인해주세요' };
  return { isValid: true };
};
